const scriptPath = 'Scripts/'

export const scripts = {
  sceneConfig: {
    name: 'ps.SceneConfig',
    path: `${scriptPath}ps/SceneConfig.js`,
  },
  editor: {
    name: 'playsmart.editor.data',
    path: '',
  },
  layout: {
    name: 'ps.Layout',
    path: '',
  },
  gridView: {
    name: 'ps.GridView',
    path: '',
  },
  languages: {
    name: 'ps.Languages',
    path: '',
  },
  movieClip: {
    name: 'ps.MovieClip',
    path: '',
  },
  editText: {
    name: 'ps.EditText',
  },
  videosManager: {
    name: 'ps.VideosManager',
  },
  video: {
    name: 'ps.Video',
  },
  audio: {
    name: 'ps.AudioNode',
  },
  verticalHorizontal: {
    name: 'ps.VerticalHorizontal',
  },
  dragonBone: {
    name: 'ps.SKPlayer',
  },
  scaleAdapter: {
    name: 'ps.ScaleAdapterMtg',
  },
  persistentEditorData: {
    name: 'ps.PEData',
  },
  qcAspectRatioFitter: {
    name: 'qc.AspectRatioFitter',
  },
  // 手势节点脚本
  emptyNode: {
    name: 'ps.EmptyNode',
  },
  mainConfig: {
    name: 'ps.MainConfig',
  },
  mainBeh: {
    name: 'MainBeh',
  },
  drawLine: {
    name: 'ps.DrawingBoard',
    path: `${scriptPath}GameplayTemplate/drawLine/view/DrawingBoard.js`,
  },
  drawLineArea: {
    name: 'ps.StartStopArea',
    path: `${scriptPath}GameplayTemplate/drawLine/view/StartStopArea.js`,
  },
  carousel: {
    name: 'ps.CarouselComponent',
    path: `${scriptPath}GameplayTemplate/carouselComponent/view/CarouselComponent.js`,
  },
  carouselGroup: {
    name: 'ps.CarouselGroupControl',
    path: `${scriptPath}GameplayTemplate/carouselComponent/view/CarouselGroupControl.js`,
  },
  carouselPit: {
    name: 'ps.CarouselPitSite',
    path: `${scriptPath}GameplayTemplate/carouselComponent/view/CarouselPitSite.js`,
  },
  carouselTool: {
    name: 'ps.CarouselTools',
    path: `${scriptPath}GameplayTemplate/carouselComponent/view/CarouselTools.js`,
  },
  carouselUi: {
    name: 'ps.GeneralCarouselUi',
    path: `${scriptPath}GameplayTemplate/carouselComponent/view/carouseltype/GeneralCarouselUi.js`,
  },
  erase: {
    name: 'ps.EraseComponent',
    path: `${scriptPath}GameplayTemplate/eraseComponent/view/EraseComponent.js`,
  },
  eraseGroup: {
    name: 'ps.EraseGroup',
    path: `${scriptPath}GameplayTemplate/eraseComponent/view/EraseGroup.js`,
  },
  eraseLayer: {
    name: 'ps.EraseLayer',
    path: `${scriptPath}GameplayTemplate/eraseComponent/view/EraseLayer.js`,
  },
  eraseArea: {
    name: 'ps.EraseArea',
    path: `${scriptPath}GameplayTemplate/eraseComponent/view/EraseArea.js`,
  },
  eraseHandImage: {
    name: 'ps.EraseHandImage',
    path: `${scriptPath}GameplayTemplate/eraseComponent/view/EraseHandImage.js`,
  },
  park: {
    name: 'ps.ParkComponent',
  },
  puzzle: {
    name: 'ps.PuzzleComponent',
  },
  mask: {
    name: 'ps.MaskComponent',
    path: `${scriptPath}GameplayTemplate/maskComponent/view/MaskComponent.js`,
  },
  maskGroup: {
    name: 'ps.MaskGroup',
    path: `${scriptPath}GameplayTemplate/maskComponent/view/MaskGroup.js`,
  },
  shelves: {
    name: 'ps.ShelvesComponent',
  },
}
